module.exports = __webpack_public_path__ + "assets/icons/star.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/svg/star.svg
// module id = 5apT
// module chunks = 1